export enum VentureTagsModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
